module.exports = __webpack_public_path__ + "457c45dea7f01848c1c5e82296cacdae.svg";